import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Back from '../Back';
import CloseIcon from '@mui/icons-material/Close';
import { Link, Outlet } from 'react-router-dom';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '92%',
  maxWidth: 420,
  maxHeight: '92vh',
  overflowY: 'auto',
  bgcolor: 'white',
  borderRadius: '24px',
  boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
  outline: 'none',
};

export default function NamePlan({ handleClose }) {
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={true}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 400,
          sx: { backgroundColor: 'rgba(0, 0, 0, 0.55)' },
        }}
      >
        <Fade in={true}>
          <Box sx={style} className='p-6'>
            <div>
              <div className='flex justify-between items-center mb-6'>
                <Back />
                <Link to='/save'>
                  <div
                    onClick={handleClose}
                    className='w-8 h-8 rounded-full bg-[#18191B] hover:bg-black text-white flex items-center justify-center cursor-pointer transition shadow-xs'
                    aria-label="Close"
                  >
                    <CloseIcon sx={{ fontSize: 16 }} />
                  </div>
                </Link>
              </div>
              <div>
                <Outlet />
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}